import { useEffect } from "react";
import { observer } from "mobx-react";
import { LoadingIndicator } from "@/components-v2/LoadingIndicator";
import { useDispatch, useRootStore, useUserStore } from "@/stores/RootStoreContext";
import { initAcceptUserTerms, prepAcceptUserTerms } from "./acceptUserTermsDomain";
import { AcceptUserTermsView } from "./acceptUserTermsComponents";

export const AcceptUserTermsPage = observer(() => {
  const rootStore = useRootStore();
  const userStore = useUserStore();
  const dispatch = useDispatch();
  const email = userStore.user?.email;

  useEffect(() => {
    dispatch([initAcceptUserTerms(email)]);
  }, [dispatch, email]);

  const props = prepAcceptUserTerms({
    state: rootStore.acceptUserTerms,
    user: userStore.user,
    companies: userStore.companies,
    dispatch,
    onAccepted: userStore.setUserTermsAccepted,
  });
  return props ? <AcceptUserTermsView {...props} /> : <LoadingIndicator fullscreen />;
});
